module.exports = __webpack_public_path__ + "static/media/Logo.ef2ceb51.png";